<template>
  <div class="tm-audio-ghost" :style="styleObj">
    <template v-if="$props.mode === AudioGhostMode.DEFAULT">
      <div>Drag to Timeline</div>
    </template>
    <template v-else-if="$props.mode === AudioGhostMode.APPEND">
      <div>Append</div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { AudioGhostMode } from 'v/Story/Timeline/api/model';

export default {
  name: 'tm-audio-ghost',

  props: {
    audio: { type: Object, required: true },
    point: { type: Object, required: true },
    mode: { type: String, required: false, default: null },
    isInside: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      zMovableGhost: (state) =>
        state.CONST.Z_ORDER.MAIN.indexOf('zMovableGhost'),
      pxAudioTrackH: (state) => state.cssVariables.pxAudioTrackH,
    }),

    AudioGhostMode() {
      return AudioGhostMode;
    },

    styleObj() {
      return {
        top: `${this.point.y}px`,
        left: `${this.point.x}px`,
        height: `${this.pxAudioTrackH}px`,
        'z-index': this.zMovableGhost,
        transform: 'translate3d(-50%, -50%, 0)',
      };
    },
  },
};
</script>

<style lang="scss">
.tm-audio-ghost {
  position: absolute;
  box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  font-weight: $font-weight-medium;
  color: white;
  cursor: var(--tm-cursor);
  background-color: rgba(#000, 0.6);
  text-shadow: 0 2px 2px rgba(#000, 0.5);
  // TODO: ...
}
</style>
